import {
  firstOrNull1982767dljvdy as firstOrNull,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  singleOrNull21olsob387p54 as singleOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  plus2opbwe063z9pg as plus,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  RemoveToggleSemantic_getInstancet61nqekdjv1v as RemoveToggleSemantic_getInstance,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  maybeSpecCenteredText3k2zk0rmdqomq as maybeSpecCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  maybeSpecCenteredText1iusdmvklvsob as maybeSpecCenteredText_0,
} from '../theming/buttons.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../components/nav/crowpay.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { weightt34o7llf2uyq as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  times2ukvaf6yk96p2 as times,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77 } from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  awaitqeg6zusi9ora as await_0,
  await1kke5zj2piplv as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance } from '../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ScopeView2pjeasrtqdymw as ScopeView } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  Draft43syxm8fng0j as Draft,
  Draft3jz09icer2h2u as Draft_0,
} from '../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_scopeTitle3b12utn8vsli8 as get_scopeTitle,
  get_description20dyln4owxipr as get_description,
} from '../../../../../crowpay-shared/com/crowpay/ScopeViewFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { nullToBlank2cwx9yazfqg5v as nullToBlank } from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic } from '../theming/states.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../utils/Draft.ext.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkboxSelectLineItems(_this__u8e3s4, selectedItems, items, scopeSet) {
  var sharedState = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0_safe_receiver = firstOrNull($this$remember.baj(selectedItems));
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kfy();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var select = selectedItems.aan(item);
    var allowed = remember(VOID, VOID, VOID, checkboxSelectLineItems$lambda(sharedState, item));
    var tmp = view.hbb(RemoveToggleSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (ToggleButton())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.eba(get_AppDimensions().jg2_1);
    if (scopeSet) {
      var tmp_0 = KMutableProperty0();
      var tmp_1 = ToggleButton$_get_enabled_$ref_7dbgch(view_0);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, ToggleButton$_set_enabled_$ref_mx2pzf(view_0));
      reactiveScope(view_0, checkboxSelectLineItems$lambda_0(this_0, allowed));
    }
    var tmp_2 = get_compact(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xbm(false);
    if (get_viewIsWide(view_1)) {
      sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_rem(1.5), get_rem(1.5));
    }
    var tmp_3 = get_centered(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Checkbox())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    if (scopeSet) {
      var tmp_4 = KMutableProperty0();
      var tmp_5 = Checkbox$_get_enabled_$ref_57hbqa(view_2);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Checkbox$_set_enabled_$ref_zhvi26(view_2));
      reactiveScope(view_2, checkboxSelectLineItems$lambda_1(this_1, allowed));
    }
    view_2.xah(view_2.cbk_1, select);
    view_1.fbb(p_2, view_2);
    view_1.jbb(tmp_3, view_2);
    var tmp_6 = view_1.ibb(get_expanding(view_1), get_centered(view_1));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.ebb(p_3, view_3);
    view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = item.lf9_1;
    var tmp_7 = view_3.tb5_1;
    var tmp_8;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_8 = '\xA0';
    } else {
      tmp_8 = value;
    }
    tmp_7.fbu(tmp_8);
    view_1.fbb(p_3, view_3);
    view_1.jbb(tmp_6, view_3);
    var tmp_9 = view_1.ibb(weight(view_1, get_viewIsNarrow(view_1) ? 1.0 : 0.8), get_centered(view_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_4 = view_1.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
    view_1.ebb(p_4, view_4);
    view_4.xbm(false);
    var tmp_10 = view_4.ibb(weight(view_4, 1.0), get_centered(view_4));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (TextView())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
    dynamicTheme(view_5, checkboxSelectLineItems$lambda_2(allowed, item));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value_0 = item.kfy().j9b_1;
    var tmp_11 = view_5.tb5_1;
    var tmp_12;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value_0) === 0) {
      tmp_12 = '\xA0';
    } else {
      tmp_12 = value_0;
    }
    tmp_11.fbu(tmp_12);
    view_5.bbs(Align_Center_getInstance());
    view_4.fbb(p_5, view_5);
    view_4.jbb(tmp_10, view_5);
    var tmp_13 = view_4.ibb(weight(view_4, 0.8), get_centered(view_4));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (TextView())(view_4.pc());
    var tmp0_elvis_lhs_6 = view_4.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.ebb(p_6, view_6);
    view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value_1 = MonetaryValue__toString_impl_xslc77(item.v91());
    var tmp_14 = view_6.tb5_1;
    var tmp_15;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value_1) === 0) {
      tmp_15 = '\xA0';
    } else {
      tmp_15 = value_1;
    }
    tmp_14.fbu(tmp_15);
    view_6.bbs(Align_Center_getInstance());
    view_4.fbb(p_6, view_6);
    view_4.jbb(tmp_13, view_6);
    view_1.fbb(p_4, view_4);
    view_1.jbb(tmp_9, view_4);
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_2, view_1);
    view_0.xah(view_0.ncq_1, select);
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function NewScopeViewDialog(options, scopeSet, withSelection) {
  withSelection = withSelection === VOID ? null : withSelection;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = options.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!element.y91()) {
      destination.v(element);
    }
  }
  var tmp = destination;
  var tmp_0 = scopeSet ? Set_instance : View_instance;
  return new (CreateScopeViewDialog())(tmp, tmp_0, NewScopeViewDialog$slambda_0(withSelection));
}
var ViewClass;
function View() {
  if (ViewClass === VOID) {
    class $ {
      toString() {
        return 'View';
      }
      hashCode() {
        return 426576929;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof View()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'View');
    ViewClass = $;
  }
  return ViewClass;
}
var View_instance;
function View_getInstance() {
  return View_instance;
}
var SetClass;
function Set() {
  if (SetClass === VOID) {
    class $ {
      toString() {
        return 'Set';
      }
      hashCode() {
        return -263337114;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Set()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Set');
    SetClass = $;
  }
  return SetClass;
}
var Set_instance;
function Set_getInstance() {
  return Set_instance;
}
var SubscopeClass;
function Subscope() {
  if (SubscopeClass === VOID) {
    class $ {
      constructor(parent) {
        this.kif_1 = parent;
      }
      toString() {
        return 'Subscope(parent=' + this.kif_1.toString() + ')';
      }
      hashCode() {
        return this.kif_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Subscope()))
          return false;
        if (!this.kif_1.equals(other.kif_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Subscope');
    SubscopeClass = $;
  }
  return SubscopeClass;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.sif_1.pif_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.kf9_1;
    destination.v(tmp$ret$1);
  }
  var tmp_0 = $this.sif_1.mif_1($this.sif_1.qif_1, destination, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  get_dialogStack().ngd();
  return Unit_instance;
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(_this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? get_expanding(_this__u8e3s4) : Companion_getInstance();
}
function CreateScopeViewDialog$options$lambda(it) {
  return it.e99() == null;
}
function CreateScopeViewDialog$options$lambda_0(it) {
  return it.hf9_1.b6l_1;
}
var CreateScopeViewDialog$render$slambdaClass;
function CreateScopeViewDialog$render$slambda() {
  if (CreateScopeViewDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateScopeViewDialog$render$slambdaClass = $;
  }
  return CreateScopeViewDialog$render$slambdaClass;
}
function CreateScopeViewDialog$render$slambda_0() {
  var i = new (CreateScopeViewDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var CreateScopeViewDialog$render$slambdaClass_0;
function CreateScopeViewDialog$render$slambda_1() {
  if (CreateScopeViewDialog$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateScopeViewDialog$render$slambdaClass_0 = $;
  }
  return CreateScopeViewDialog$render$slambdaClass_0;
}
function CreateScopeViewDialog$render$slambda_2() {
  var i = new (CreateScopeViewDialog$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var CreateScopeViewDialog$render$slambdaClass_1;
function CreateScopeViewDialog$render$slambda_3() {
  if (CreateScopeViewDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.sif_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateScopeViewDialog$render$slambdaClass_1 = $;
  }
  return CreateScopeViewDialog$render$slambdaClass_1;
}
function CreateScopeViewDialog$render$slambda_4(this$0) {
  var i = new (CreateScopeViewDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var CreateScopeViewDialogClass;
function CreateScopeViewDialog() {
  if (CreateScopeViewDialogClass === VOID) {
    class $ {
      constructor(options, intent, withSelection) {
        this.lif_1 = intent;
        this.mif_1 = withSelection;
        var tmp = this;
        var tmp0_subject = this.lif_1;
        var tmp_0;
        if (equals(tmp0_subject, Set_instance)) {
          tmp_0 = true;
        } else {
          if (tmp0_subject instanceof Subscope()) {
            tmp_0 = this.lif_1.kif_1.p7z_1;
          } else {
            if (equals(tmp0_subject, View_instance)) {
              tmp_0 = false;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        tmp.nif_1 = tmp_0;
        var tmp_1 = this;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = options.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (this.nif_1 ? element.kfy().d4(LineItemState_Complete_getInstance()) < 0 : true) {
            destination.v(element);
          }
        }
        var tmp_2 = destination;
        var tmp_3 = CreateScopeViewDialog$options$lambda;
        tmp_1.oif_1 = sortedWith(tmp_2, compareBy([tmp_3, CreateScopeViewDialog$options$lambda_0]));
        this.pif_1 = ReactiveMutableList().tam();
        var tmp_4 = this;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().u(collectionSizeOrDefault(options, 10));
        var _iterator__ex2g4s_0 = options.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var item = _iterator__ex2g4s_0.o1();
          var tmp$ret$3 = item.jfy();
          destination_0.v(tmp$ret$3);
        }
        var tmp0_elvis_lhs = singleOrNull(toSet(destination_0));
        var tmp_5;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().a1('All options must be from the same project');
        } else {
          tmp_5 = tmp0_elvis_lhs;
        }
        tmp_4.qif_1 = validated(Draft(new (ScopeView())(VOID, tmp_5, '', VOID, VOID, equals(this.lif_1, Set_instance))));
        var tmp_6 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.qif_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_7 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
        var tmp$ret$6 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$6);
        var tmp$ret$8 = get_scopeTitle(it);
        var tmp$ret$9 = lensPath(this_0, tmp$ret$8);
        tmp_6.rif_1 = assertNotBlank(tmp$ret$9);
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(CreateScopeViewDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        view.zb8(get_AppDimensions().wg1_1);
        var tmp = view.ibb(view.ibb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, plus(get_rem_0(40), times(get_AppDimensions().wg1_1, 2)), plus(get_rem_0(40), times(get_AppDimensions().wg1_1, 2)))), view.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().xg1_1);
        var tmp0_subject = this.lif_1;
        var tmp_0;
        if (equals(tmp0_subject, View_instance)) {
          tmp_0 = 'New Scope View';
        } else {
          if (equals(tmp0_subject, Set_instance)) {
            tmp_0 = 'New Scope Set';
          } else {
            if (tmp0_subject instanceof Subscope()) {
              tmp_0 = 'New Scope Group';
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        title(view_1, tmp_0);
        var tmp1_subject = this.lif_1;
        var tmp_1;
        if (equals(tmp1_subject, View_instance) || equals(tmp1_subject, Set_instance)) {
          tmp_1 = 'Scope Title';
        } else {
          if (tmp1_subject instanceof Subscope()) {
            tmp_1 = 'Group Title';
          } else {
            noWhenBranchMatchedException();
          }
        }
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = tmp_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_AppDimensions().pg2_1);
        view_3.jbb(get_centered(view_3), bodyBold(view_3, label));
        view_3.jbb(colored(view_3, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_3, '*'));
        view_2.fbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_2.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextInput())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'Scope Title';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_4.tb5_1.zb3_1.ib7_1.placeholder = value;
        view_4.xah(view_4.gcn_1, this.rif_1);
        view_2.fbb(p_4, view_4);
        view_2.jbb(tmp_2, view_4);
        view_1.fbb(p_2, view_2);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_0 = 'Description (Optional)';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.ebb(p_5, view_5);
        view_5.xbm(true);
        view_5.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_5, label_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_3 = view_5.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.qif_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_4 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
        var tmp$ret$17 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$17);
        var tmp$ret$19 = get_description(it);
        var desc = lensPath(this_0, tmp$ret$19);
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextArea())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.tcl('Description');
        view_6.xah(view_6.qcl_1, nullToBlank(desc));
        view_5.fbb(p_6, view_6);
        view_5.jbb(tmp_3, view_6);
        view_5.jbb(view_5.hbb(SubtextSemantic_getInstance()), errorText(view_5));
        view_1.fbb(p_5, view_5);
        var tmp_5 = get_expanding(view_1);
        view_1.jbb(tmp_5, label2(view_1, 'Add Work Items', VOID, ($this$label2) => $this$label2.jbb($this$label2.ibb(get_expanding($this$label2), get_scrolling($this$label2)), checkboxSelectLineItems($this$label2, this.pif_1, this.oif_1, this.nif_1))));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_7 = view_1.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.ebb(p_7, view_7);
        view_7.xbm(false);
        var tmp_6 = view_7.ibb(view_7.ibb(get_centered(view_7), render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(view_7)), get_secondaryButton(view_7));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.ebb(p_8, view_8);
        maybeSpecCenteredText(view_8, 'Discard');
        onClick(view_8, 'Discard Scope View', VOID, CreateScopeViewDialog$render$slambda_2());
        view_7.fbb(p_8, view_8);
        view_7.jbb(tmp_6, view_8);
        var tmp_7 = view_7.ibb(render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(view_7), get_primaryButton(view_7));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_9 = view_7.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
        view_7.ebb(p_9, view_9);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = Button$_get_enabled_$ref_61t7nx(view_9);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(view_9));
        reactiveScope(view_9, ($this$reactiveScope) => {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$reactiveScope.baj(this.pif_1).i1()) {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_0 = $this$reactiveScope.baj(this.rif_1);
            tmp = !isBlank(this_0);
          } else {
            tmp = false;
          }
          var tmp$ret$35 = tmp;
          this_1.set(tmp$ret$35);
          return Unit_instance;
        });
        maybeSpecCenteredText_0(view_9, ($this$maybeSpecCenteredText) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$maybeSpecCenteredText.baj(this.rif_1);
          var tmp;
          if (isBlank(this_0)) {
            var tmp0_subject = this.lif_1;
            var tmp_0;
            if (equals(tmp0_subject, View_instance)) {
              tmp_0 = 'Scope View';
            } else {
              if (equals(tmp0_subject, Set_instance)) {
                tmp_0 = 'Scope Set';
              } else {
                if (tmp0_subject instanceof Subscope()) {
                  tmp_0 = 'Scope Group';
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
            tmp = tmp_0;
          } else {
            tmp = this_0;
          }
          return 'Create ' + tmp;
        });
        var tmp_10 = this.nif_1 ? 'Create Scope Set' : 'Create Scope View';
        onClick(view_9, tmp_10, VOID, CreateScopeViewDialog$render$slambda_4(this));
        view_7.fbb(p_9, view_9);
        view_7.jbb(tmp_7, view_9);
        view_1.fbb(p_7, view_7);
        view_0.fbb(p_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'CreateScopeViewDialog', VOID, VOID, [Page()]);
    CreateScopeViewDialogClass = $;
  }
  return CreateScopeViewDialogClass;
}
function checkboxSelectLineItems$lambda($sharedState, $item) {
  return ($this$remember) => {
    var s = $this$remember.baj($sharedState);
    return s == null || equals(s, $item.kfy());
  };
}
function ToggleButton$_get_enabled_$ref_7dbgch(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ToggleButton.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.mcq_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function ToggleButton$_set_enabled_$ref_mx2pzf(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ToggleButton.enabled' call
    var tmp0 = p0.mcq_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function checkboxSelectLineItems$lambda_0($this, $allowed) {
  return ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj($allowed);
    $this.set(tmp$ret$0);
    return Unit_instance;
  };
}
function Checkbox$_get_enabled_$ref_57hbqa(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Checkbox$_set_enabled_$ref_zhvi26(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function checkboxSelectLineItems$lambda_1($this, $allowed) {
  return ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj($allowed);
    $this.set(tmp$ret$0);
    return Unit_instance;
  };
}
function checkboxSelectLineItems$lambda_2($allowed, $item) {
  return ($this$dynamicTheme) => $this$dynamicTheme.baj($allowed) ? LineItemStateSemantic($item.kfy()) : null;
}
function *_generator_invoke__zhh2q8_0($this, draft, selected, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = pushChanges(draft, session.ufv_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var scope = tmp_0;
  var tmp_1 = session.tfw().vfg_1.zfq(scope.k7z_1, selected, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_safe_receiver = $this.tif_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp_2 = tmp0_safe_receiver(scope, selected, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var NewScopeViewDialog$slambdaClass;
function NewScopeViewDialog$slambda() {
  if (NewScopeViewDialog$slambdaClass === VOID) {
    class $ {
      constructor($withSelection) {
        this.tif_1 = $withSelection;
      }
      shp(draft, selected, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, draft, selected), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Draft_0()) : false) ? p1 : THROW_CCE();
        return this.shp(tmp, (!(p2 == null) ? isInterface(p2, KtList()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    NewScopeViewDialog$slambdaClass = $;
  }
  return NewScopeViewDialog$slambdaClass;
}
function NewScopeViewDialog$slambda_0($withSelection) {
  var i = new (NewScopeViewDialog$slambda())($withSelection);
  var l = (draft, selected, $completion) => i.shp(draft, selected, $completion);
  l.$arity = 2;
  return l;
}
//region block: init
View_instance = new (View())();
Set_instance = new (Set())();
//endregion
//region block: exports
export {
  Subscope as Subscopelwws6cwdmjzk,
  CreateScopeViewDialog as CreateScopeViewDialog2bw9ryrzjhk1t,
  NewScopeViewDialog as NewScopeViewDialog2llneu31ficjx,
  checkboxSelectLineItems as checkboxSelectLineItems1dke5tjc0acqf,
};
//endregion

//# sourceMappingURL=NewScopeViewDialog.mjs.map
